// extracted by mini-css-extract-plugin
export var label = "_4t-1";
export var reminder = "_4t-0";